export default window.__config || {
  apiUrl: "http://localhost:9000",
  webSocketUrl: "ws://localhost:9000",
  sentryDsn: null,
  sentryEnvironment: null,
  decrementCallRateLimitTimer: 3600000, // 3600000ms = 1 hour
  rawrSocket: "ws://localhost:3012",
  twilioUrl: "http://todo",
  pusher: {
    key: "d2f27160a9189f0103f9",
    cluster: "us2",
  },
  firebase: {
    apiKey: "AIzaSyCwTjeB9yzDcbAiRaRUXsKDwQAblW7Q5MI",
    authDomain: "gatehawk-intercom-dev.firebaseapp.com",
    projectId: "gatehawk-intercom-dev",
    storageBucket: "gatehawk-intercom-dev.appspot.com",
    messagingSenderId: "460429714952",
    appId: "1:460429714952:web:919802bf6eea035f4fd3bd",
    measurementId: "G-HHBERJZT3M",
  },
  launchDarklyKey: "6303a50854e511124387c35c",
};
